import CopyToClipboard from "components/components/CopyToClipboard/CopyToClipboard";
import React from "react";

import {
  ClientSecretDetailsContainer,
  ClientSecretDetailsLabel,
  ClientSecretDetailsRow,
  ClientSecretDetailsValue,
} from "./style";

type Props = {
  secretValue?: string;
  expiryValue?: string;
};

const ClientSecretDetails: React.FC<Props> = ({ secretValue, expiryValue }) => (
  <ClientSecretDetailsContainer>
    <ClientSecretDetailsRow>
      <ClientSecretDetailsLabel>Client secret</ClientSecretDetailsLabel>
      <ClientSecretDetailsValue>{secretValue}</ClientSecretDetailsValue>
      {secretValue ? (
        <CopyToClipboard value={secretValue} label="Client secret" />
      ) : (
        <span />
      )}
    </ClientSecretDetailsRow>
    <ClientSecretDetailsRow>
      <ClientSecretDetailsLabel>Expiry</ClientSecretDetailsLabel>
      <ClientSecretDetailsValue>{expiryValue}</ClientSecretDetailsValue>
      <span />
    </ClientSecretDetailsRow>
  </ClientSecretDetailsContainer>
);

export default ClientSecretDetails;
